export default __webpack_public_path__ + "static/1-dd74f6a830ce84520baa4945fb4c5979.jpg";